export default {
      id: "business-criminal-usage",
      viewBox: "0 0 26 32",
      url: __webpack_public_path__ + "sprite.svg#business-criminal",
      toString: function () {
        return this.url;
      }
    }